import RestClient from './../../service/rest-client';
import {Signal} from 'signals';
import moment from 'moment'
import utils from './../../component/utils/utils'

class Service {

    event = {
        onFetchShipmentStatsPerDay: new Signal(),
        onFetchSendShipmentStatsByCountry: new Signal(),
        onFetchSendShipmentsBySource: new Signal(),
        onFetchAveragePackageInShipmentPerDayChartData: new Signal(),
        onFetchShipmentsPackagesByDay: new Signal(),
        onFetchShipmentsPackagesByMonth: new Signal(),
    };

    fetchShipmentStatsPerDay(intervalDates, typeOfRequest) {
        intervalDates = intervalDates || 1;
        typeOfRequest = typeOfRequest || 'table';

       RestClient.isSessionActive();
        var queryParams = [`interval_days=${ intervalDates }`];

          var urlRequestTemplate = "/reporting/shipmentstats/perday?" + queryParams.join("&");

           return RestClient.getRequest(urlRequestTemplate,"").then((data) => {
               var page = data.page_number;
               var pageSize = data.page_size,
                   offset = (page - 1) * pageSize;
               var pagingMetadata = {
                   page: data.page_number,
                   startIndex: offset + 1,
                   endIndex: offset + pageSize,
                   totalCount: data.total_count,
                   pageCount: Math.max(Math.ceil(data.total_count / pageSize), 1)//Always 1 page, even if 0 results
               };
                   data.pagingMetadata = pagingMetadata;
                   data.results = this.parseRequestDataShipmentStatsPerDay(data.results);
                   this.event.onFetchShipmentStatsPerDay.dispatch(data);
           }).catch((error) => {
               console.log("Error: " + error);
           });
    }

    parseRequestDataShipmentStatsPerDay(resultData) {
        var parsedArray = resultData.map(function(dataItem) {
            var parsedObject = {};
            parsedObject.id = dataItem.id;
            parsedObject.dateShiped = moment(dataItem.dateShiped).format("L");
            parsedObject.count = dataItem.countItems;

            return parsedObject;
        });
        return parsedArray;
    }

    // start histogram by country
    fetchSendShipmentStatsByCountry(intervalDays) {
        RestClient.isSessionActive();
        var queryParams = [`interval_days=${ intervalDays }`];
        var urlRequestTemplate = "/reporting/shipmentstats/bycountry?" + queryParams.join("&");

        return RestClient.getRequest(urlRequestTemplate,"").then( (data) => {
            var chartData = this.parseRequestDataShipmentByCountry(data.results);
            this.event.onFetchSendShipmentStatsByCountry.dispatch(chartData);
        }).catch((error) => {
            console.log("Error: " + error);
        });
    }

    parseRequestDataShipmentByCountry(resultData) {
        var chartData = {
            categoryList : [],
            seriesDataList: []
        };

        resultData.forEach(function(dataItem) {
            chartData.categoryList.push(dataItem.countryName);
            chartData.seriesDataList.push(dataItem.countItems);
        });

        return chartData;
    }
    // end histogram by country

    // start histogram by source
    fetchSendShipmentStatsBySource(intervalDays) {
        RestClient.isSessionActive();
        var queryParams = [`interval_days=${ intervalDays }`];

        var urlRequestTemplate = "/reporting/shipmentstats/bysource?" + queryParams.join("&");

        return RestClient.getRequest(urlRequestTemplate,"").then( (data) => {
            var chartData = this.parseSendShipmentDataBySource(data.results);
            this.event.onFetchSendShipmentsBySource.dispatch(chartData);
        }).catch((error) => {
            console.log("Error: " + error);
        });
    }

    parseSendShipmentDataBySource(resultData) {
        var chartData = {
            categoryList : [],
            seriesDataList: []
        };

        resultData.forEach(function(dataItem) {
            chartData.categoryList.push(dataItem.utmSource.replace(/first:|last:/gi, ''));
            chartData.seriesDataList.push(dataItem.countItems);
        });

        return chartData;
    }
    // end histogram by source

    // start block chart average package in shipment per day
    fetchAveragePackageShipmentStats(intervalDays) {
        RestClient.isSessionActive();
        var queryParams = [`interval_days=${ intervalDays }`];

        var urlRequestTemplate = "/reporting/shipmentstats/averagepackageinshipmentbyday?" + queryParams.join("&");

        return RestClient.getRequest(urlRequestTemplate,"").then( (data) => {
            data.chartData = this.parseAveragePackageShipmentData(data.results);
            this.event.onFetchAveragePackageInShipmentPerDayChartData.dispatch(data);
        }).catch((error) => {
            console.log("Error: " + error);
        });
    }

    parseAveragePackageShipmentData(resultData) {
        var chartData = {
            categoryList : [],
            seriesDataList1: [],
        };

        resultData.forEach(function(dataItem) {
            chartData.categoryList.push(moment(dataItem.dateShiped).format(utils.shortDateFormat));
            chartData.seriesDataList1.push(dataItem.averagePackageShipment);
        });

        return chartData;
    }
    // end histogram by subject

    fetchShipmentSeriesByDay(intervalDates) {
        intervalDates = intervalDates || 1;

        RestClient.isSessionActive();
        var queryParams = [`interval_days=${ intervalDates }`];

        var urlRequestTemplate = "/reporting/shipmentstats/byseries?" + queryParams.join("&");

        return RestClient.getRequest(urlRequestTemplate,"").then((data) => {
            data.chartData = this.parseRequestDataSeriesForShipmentByDayStatistics(data.results);
            console.log("Series getRequest");
            console.log(data);
            this.event.onFetchShipmentsPackagesByDay.dispatch(data);
        }).catch((error) => {
            console.log("Error: " + error);
        });
    }

    parseRequestDataSeriesForShipmentByDayStatistics(resultData) {
        var chartData = {
            categoryList : [],
            seriesDataList1: [],
            seriesDataList2: [],
            seriesDataList3: []
        };

        resultData.forEach(function(dataItem) {
            chartData.categoryList.push(moment(dataItem.dateShiped).format(utils.shortDateFormat));
            chartData.seriesDataList1.push(dataItem.totalShipmentCount);
            chartData.seriesDataList2.push(dataItem.newShipmentCount);
            chartData.seriesDataList3.push(dataItem.repeatShipmentCount);

        });

        return chartData;
    }

    fetchShipmentSeriesByMonth(intervalDates) {
        intervalDates = intervalDates || 365;

        RestClient.isSessionActive();
        var queryParams = [`interval_days=${ intervalDates }`];

        var urlRequestTemplate = "/reporting/shipmentstats/byseries?" + queryParams.join("&");

        return RestClient.getRequest(urlRequestTemplate,"").then((data) => {
            data.chartData = this.parseRequestDataSeriesForShipmentByMonthStatistics(data.results);
            console.log("Series get shipments by month:");
            console.log(data);
            this.event.onFetchShipmentsPackagesByMonth.dispatch(data);
        }).catch((error) => {
            console.log("Error: " + error);
        });
    }

    parseRequestDataSeriesForShipmentByMonthStatistics(resultData) {
        var chartData = {
            categoryListByMonth : [],
            seriesDataListByMonth1: [],
            seriesDataListByMonth2: [],
            seriesDataListByMonth3: []
        };

        resultData.forEach(function(dataItem) {
            chartData.categoryListByMonth.push(moment(dataItem.dateShiped).format("MM/YYYY"));
            chartData.seriesDataListByMonth1.push(dataItem.totalShipmentCount);
            chartData.seriesDataListByMonth2.push(dataItem.newShipmentCount);
            chartData.seriesDataListByMonth3.push(dataItem.repeatShipmentCount);

        });

        return chartData;
    }
}

export default new Service();